import React from "react";
import "./Cancel_Order_btn.css";
import { Button } from "react-bootstrap";

function Cancel_Order_btn({ btnText, onClick }) {
  return (
    <>
      <section className="Cancel_Order_btn_holder">
        <Button className="Cancel_Order_btn" onClick={onClick}>{btnText}</Button>
      </section>
    </>
  );
}

export default Cancel_Order_btn;
